import React from 'react'
import { useSelector } from 'react-redux'
import SettingsSelect from '../../shared/components/SettingsSelect/SettingsSelect'

interface ActivitySponsorTypeFieldProps {
    value: string
    onChange: (val: string) => void
    disabled?: boolean
    existingValue?: string
    error?: boolean
    helperText?: string
    required?: boolean
}

const ActivitySponsorTypeField: React.FC<ActivitySponsorTypeFieldProps> = ({
    value,
    onChange,
    disabled,
    existingValue,
    error,
    helperText,
    required,
}) => {
    // Read reactively so options appear as soon as settings load into Redux, rather than
    // capturing a one-time snapshot that can be the stale, localStorage-persisted copy.
    // @ts-expect-error redux store is not typed
    const rawOptions: string[] = useSelector((state) => state?.settings?.sponsorTypes) || []
    const options = rawOptions.map((s) => ({ value: s, label: s }))

    return (
        <SettingsSelect
            value={value}
            onChange={onChange}
            options={options}
            placeholder="Select Sponsor Type"
            disabled={disabled}
            existingValue={existingValue}
            error={error}
            helperText={helperText}
            required={required}
        />
    )
}

export default ActivitySponsorTypeField
